export default __webpack_public_path__ + "static/media/PaydayLoanAgreement_ON.947a128c.pdf";